<script>
    import IconButton, { Icon } from "@smui/icon-button";
    import DataTable, { Head, Body, Row, Cell, Label } from "@smui/data-table";
    import Tooltip, { Wrapper, Content } from "@smui/tooltip";
    import { mdiContentSaveOutline, mdiContentSave, mdiCloseThick, mdiAlertCircle, mdiAlertBox } from "@mdi/js";
    import { _ } from "svelte-i18n";

    export let status;
    export let caseAutoroundStyle = "none";
    export let caseAutoround = 0;
    export let countryAutoround = 0;
    export let rowStyle = "";


</script>

{#if caseAutoroundStyle == "icon"}

    <Cell class="{rowStyle} right-splitter-sub">
    <div class="flex cell-contents">
        <span class="">
            <span class="">{$_(status == "new"? "not_bought": status)}</span>
        </span>
        {#if caseAutoround && caseAutoround != null && caseAutoround == 1}
            <span title={$_("case_autoround_applied")} class="orange-text">
                <IconButton size="mini" class="range-text pt-0 pb-0 pl-0 pr-0" disabled={true}>
                    <Icon tag="svg" viewBox="0 0 24 24" class="orange-text">
                    <path fill="currentColor" d={mdiAlertCircle} />
                    </Icon>
                </IconButton>
            </span>
        {/if}
        {#if countryAutoround && countryAutoround != null && countryAutoround == 1}
            <span title={$_("country_autoround_applied")} class="orange-text">
                <IconButton size="mini" class="range-text pt-0 pb-0 pl-0 pr-0" disabled={true}>
                    <Icon tag="svg" viewBox="0 0 24 24" class="grey-text">
                    <path fill="currentColor" d={mdiAlertCircle} />
                    </Icon>
                </IconButton>
            </span>
        {/if}
    </div>
    </Cell>

{:else}
    <Cell class="right-splitter-sub {rowStyle}">
    <div class="cell-contents">
        <span class="">
            <span class="">{$_(status == "new"? "not_bought": status)}</span>
        </span>
    </div>
    </Cell>
{/if}

<style>
  .cell-contents {
     display: flex;
     flex-direction: row;
     justify-content: left;
     align-items: center;
  }
</style>
